import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import jsonp from 'jsonp';
import canUseDOM from 'exenv';

import featureFlags from '../../../../feature_flags';
import log from '../../../services/logger_service';

export default class RevContent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      revcontentStories: null
    };
    this.storiesRequested = false;
    this.revDiv = null;
  }

  componentDidMount() {
    if (
      !this.state.revcontentStories &&
      !this.storiesRequested &&
      !featureFlags.revContentJSWidgetEnabled
    ) {
      this.getRCData();
      this.storiesRequested = true;
    }
  }

  componentWillReceiveProps() {
    if (featureFlags.revContentJSWidgetEnabled) {
      if (
        !this.props.initialPageLoad &&
        canUseDOM &&
        this.storiesRequested === false
      ) {
        const widgetID = this.props.site === 'fastcompany' ? '77613' : '85314';

        /* eslint-disable */
        let referer = '';
        try {
          if (((referer = document.referrer), typeof referer === 'undefined'))
            throw 'undefined';
        } catch (exception) {
          (referer = document.location.href), (referer == '' ||
            typeof referer === 'undefined') &&
            (referer = document.URL);
        }
        referer = referer.substr(0, 700);
        const rcel = document.createElement('script');
        rcel.id = `rc_${Math.floor(Math.random() * 1000)}`;
        rcel.type = 'text/javascript';
        rcel.src = `https://trends.revcontent.com/serve.js.php?w=${widgetID}&t=${rcel.id}&c=${new Date().getTime()}&width=${window.outerWidth ||
          document.documentElement.clientWidth}&referer=${referer}`;
        rcel.async = true;
        this.revDiv.innerHTML = '';
        this.revDiv.appendChild(rcel);
        /* eslint-enable */

        this.storiesRequested = true;
      }
    }
  }

  getRCData() {
    if (!this.state.revcontentStories && !this.storiesRequested) {
      const { site } = this.props;
      const widgetID = site === 'fastcompany' ? '65657' : '65662';
      const domainID = `${site}.com`;

      const rcURL =
        '//trends.revcontent.com/api/v1/?' +
        'api_key=573921e5aacb705a54512738b54b0f0bceb4cf94' +
        '&pub_id=6590' +
        `&widget_id=${widgetID}` +
        `&domain=${encodeURI(domainID)}` +
        `&referer=${encodeURI(window.location.href)}` +
        '&format=json' +
        '&sponsored_count=4' +
        '&sponsored_offset=0' +
        '&internal_count=0' +
        '&internal_offset=0';

      jsonp(rcURL, null, (err, data) => {
        if (err) {
          log.error(err.message, 'Unable to fetch revcontent stories');
        } else {
          this.setState({
            revcontentStories: data
          });
        }
      });
    }
  }

  render() {
    if (featureFlags.revContentJSWidgetEnabled) {
      if (!this.props.initialPageLoad && canUseDOM) {
        return (
          <section className="post-more-stories post-more-stories--revcontent">
            <div
              id="rcjsload_a3c485"
              ref={revDiv => {
                this.revDiv = revDiv;
              }}
            />
          </section>
        );
      }
      return null;
    }

    if (!this.state.revcontentStories) {
      return null;
    }

    return (
      <section className="post-more-stories post-more-stories--revcontent">
        <div className="homepage-tag__advertorial-title-container">
          <div>
            <div className="slug-component">
              <h2 className="slug category-page__slug">From Around The Web</h2>
            </div>
            <h3 className="page-description">Powered by RevContent</h3>
          </div>
        </div>
        <div className="row row--revcontent">
          {this.state.revcontentStories.map(story => (
            <div key={story.url} className="card-wrapper card-wrapper--4">
              <article className="card">
                <a href={story.url} title={story.headline}>
                  <figure className="poster">
                    <div>
                      <img src={story.image} alt={story.headline} />
                    </div>
                  </figure>
                  <div className="text-wrapper">
                    <span className="eyebrow">{story.brand}</span>
                    <h2 className="title">{story.headline}</h2>
                  </div>
                </a>
              </article>
            </div>
          ))}
        </div>
      </section>
    );
  }
}

RevContent.defaultProps = {
  site: 'fastcompany'
};

RevContent.propTypes = {
  site: PropTypes.string,
  initialPageLoad: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/revcontent/revcontent.js